import { IKundList } from "./kundList";

export class KundListViewModel {
    constructor(private readonly model: IKundList) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get avdelning() {
        return this.model.avdelning;
    }

    get aktiv() {
        return this.model.aktiv;
    }

    get besokPostortadress() {
        return this.model.besokPostortadress;
    }

    get huvudkod() {
        return this.model.huvudkod;
    }

    get internnummer() {
        return this.model.internnummer;
    }

    get beskrivning() {
        return this.model.beskrivning;
    }

    get orgNummer() {
        return this.model.orgNummer;
    }

    get befraktare() {
        return this.model.befraktare;
    }

    get color() {
        return this.model.color;
    }

    get kundModel(): IKundList {
        return this.model;
    }
}
